import { ApiErrorData, ApiResponse } from 'models/ApiResponse';

import { FunctionsHelper } from 'utils/FunctionsHelper';
import MainBackendAxios from 'utils/MainBackendAxios';

export type PortalGoCatalogType =
  | 'KAM'
  | 'PROFILE'
  | 'UNIFORM'
  | 'GOAL'
  | 'SUPERVISOR';

export interface PortalGoCatalogItem {
  id: number;
  type: PortalGoCatalogType;
  code: string | null;
  label: string;
  description: string | null;
  sortOrder: number;
  isActive: boolean;
}

export interface PortalGoBriefCatalogs {
  kams: PortalGoCatalogItem[];
  profiles: PortalGoCatalogItem[];
  uniforms: PortalGoCatalogItem[];
  goals: PortalGoCatalogItem[];
}

const BASE = '/portal-go/catalog';

export const PortalGoCatalogService = {
  list: async (
    types?: PortalGoCatalogType[],
    activeOnly = true
  ): Promise<ApiResponse<PortalGoCatalogItem[] | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.get(`${BASE}/list`, {
        params: {
          types: types?.length ? types.join(',') : undefined,
          activeOnly,
        },
      });

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },

  getBriefCatalogs: async (): Promise<
    ApiResponse<PortalGoBriefCatalogs | ApiErrorData>
  > => {
    try {
      const response = await MainBackendAxios.get(`${BASE}/brief`);

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
};
